import SpeedOfService from './SpeedOfService';
export default SpeedOfService;